export enum ModalSectionMode {
	fieldSet = 0,
	navPills = 1,
}
